import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/AppContext";
import api, { formatApiErrorDetail } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const { t } = useApp();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset successful");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <div className="min-h-screen ps-grid-bg flex items-center justify-center px-6" data-testid="reset-page">
      <div className="ps-glow-card rounded-2xl w-full max-w-md p-8">
        <h1 className="font-head text-2xl font-bold text-white mb-6">{t("reset_password")}</h1>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label className="text-slate-300">{t("new_password")}</Label>
            <Input
              data-testid="reset-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 bg-slate-900/70 border-slate-700"
              required
            />
          </div>
          {error && <p className="text-red-400 text-sm">{error}</p>}
          <Button
            data-testid="reset-submit-btn"
            type="submit"
            className="w-full bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-head font-bold py-6"
          >
            {t("reset_password")}
          </Button>
        </form>
        <Link to="/login" className="block text-center mt-6 text-sm text-cyan-400 hover:underline">
          {t("back_to_login")}
        </Link>
      </div>
    </div>
  );
}
